import _asyncToGenerator from "/data/landun/workspace/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-6ee150b6"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h2", null, "空间管理", -1);
});

var _hoisted_2 = {
  class: "company-detail"
};
var _hoisted_3 = {
  class: "menus"
};
var _hoisted_4 = {
  class: "company-switch"
};
var _hoisted_5 = {
  key: 0,
  class: "title"
};

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("i", {
    class: "iconfont iconswitch-line change-company"
  }, null, -1);
});

var _hoisted_7 = /*#__PURE__*/_createTextVNode("切换 ");

var _hoisted_8 = [_hoisted_6, _hoisted_7];

var _hoisted_9 = /*#__PURE__*/_createTextVNode(" 基本资料 ");

var _hoisted_10 = /*#__PURE__*/_createTextVNode(" 业务信息 ");

var _hoisted_11 = /*#__PURE__*/_createTextVNode(" 使用产品 ");

var _hoisted_12 = {
  class: "detail"
};
import { ref, computed, onMounted, watchEffect, watch } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import AuthService from '@/api/auth';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var store = useStore();
    var route = useRoute();
    var router = useRouter();
    var selectedKey = ref('Basic');
    var showSelectBiz = ref(false);
    var selectedBizName = ref('');
    var loading = ref(false);
    var options = ref([]);
    var corporationId = computed(function () {
      var _route$params$company;

      return ((_route$params$company = route.params.company_id) === null || _route$params$company === void 0 ? void 0 : _route$params$company.toString()) || '';
    });
    var spaceDetail = computed(function () {
      return store.state.company.spaceDetail;
    });
    var isInMicroApp = ref(window.__MICRO_APP_ENVIRONMENT__);
    watchEffect(function () {
      selectedKey.value = route.params.appKey || route.name;
    });

    var remoteMethod = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(query) {
        var _data$data;

        var data, _data$data$result, _data$data$result$ite;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return AuthService.getBizList({
                  bizNameOrId: query,
                  // busiId: route.params.biz_url,
                  corporationId: corporationId.value
                });

              case 2:
                data = _context.sent;

                if (((_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.code) === 1) {
                  options.value = (_data$data$result = data.data.result) === null || _data$data$result === void 0 ? void 0 : (_data$data$result$ite = _data$data$result.itemList) === null || _data$data$result$ite === void 0 ? void 0 : _data$data$result$ite.map(function (item) {
                    return {
                      label: item.name,
                      value: item.id
                    };
                  });
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function remoteMethod(_x) {
        return _ref.apply(this, arguments);
      };
    }();

    var switchBiz = function switchBiz() {
      if (showSelectBiz.value) {
        showSelectBiz.value = false;
      } else {
        showSelectBiz.value = true;
        remoteMethod(spaceDetail.value.name);
      }
    };

    var changeBizName = function changeBizName() {
      router.push({
        name: route.name,
        params: {
          biz_url: selectedBizName.value
        }
      });
      showSelectBiz.value = false;
    };

    var selectMenu = function selectMenu(key, item) {
      selectedKey.value = key;

      if ((item === null || item === void 0 ? void 0 : item.length) <= 1) {
        router.push({
          name: key,
          params: {
            project: key
          }
        });
      } else {
        router.push({
          name: item[0]
        });
      }
    };

    watch(function () {
      return route.params.biz_url;
    }, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return store.dispatch('company/getSpaceDetail', {
                bizId: route.params.biz_url,
                appGroup: 'beacon'
              });

            case 2:
              _context2.next = 4;
              return store.dispatch('company/getBusiAdminList', {
                busiIdSet: [spaceDetail.value.busiId]
              });

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var _route$params$company2;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              selectedKey.value = route.params.appKey || route.name;
              corporationId.value = ((_route$params$company2 = route.params.company_id) === null || _route$params$company2 === void 0 ? void 0 : _route$params$company2.toString()) || '';
              _context3.next = 4;
              return store.dispatch('company/getSpaceDetail', {
                bizId: route.params.biz_url,
                appGroup: 'beacon'
              });

            case 4:
              _context3.next = 6;
              return store.dispatch('company/checkCompanyAdmin', {
                corporation_id: corporationId.value
              });

            case 6:
              _context3.next = 8;
              return store.dispatch('company/getBusiAdminList', {
                busiIdSet: [spaceDetail.value.busiId]
              });

            case 8:
              _context3.next = 10;
              return store.dispatch('company/checkUpdatePermission', {
                bizId: route.params.biz_url,
                appGroup: 'beacon'
              });

            case 10:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    })));
    return function (_ctx, _cache) {
      var _component_el_option = _resolveComponent("el-option");

      var _component_el_select = _resolveComponent("el-select");

      var _component_el_menu_item = _resolveComponent("el-menu-item");

      var _component_el_menu = _resolveComponent("el-menu");

      var _component_router_view = _resolveComponent("router-view");

      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['company-home', {
          'company-home-inMicro': isInMicroApp.value
        }])
      }, [_hoisted_1, _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [!showSelectBiz.value ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(spaceDetail).name), 1)) : (_openBlock(), _createBlock(_component_el_select, {
        key: 1,
        modelValue: selectedBizName.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return selectedBizName.value = $event;
        }),
        style: {
          "width": "180px"
        },
        filterable: "",
        remote: "",
        "reserve-keyword": "",
        placeholder: "请搜索选择空间",
        "remote-method": remoteMethod,
        loading: loading.value,
        onChange: changeBizName
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, function (item) {
            return _openBlock(), _createBlock(_component_el_option, {
              key: item.value,
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["modelValue", "loading"])), _createElementVNode("span", {
        class: "switch-company",
        onClick: switchBiz
      }, _hoisted_8)]), _createVNode(_component_el_menu, {
        style: {
          "width": "248px"
        },
        mode: "vertical",
        "default-active": selectedKey.value,
        onSelect: selectMenu
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_menu_item, {
            index: "SpaceBasic"
          }, {
            default: _withCtx(function () {
              return [_hoisted_9];
            }),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "SpaceInfo"
          }, {
            default: _withCtx(function () {
              return [_hoisted_10];
            }),
            _: 1
          }), _createVNode(_component_el_menu_item, {
            index: "SpaceProduct"
          }, {
            default: _withCtx(function () {
              return [_hoisted_11];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["default-active"])]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_router_view)])])], 2);
    };
  }
});